module.exports = __webpack_public_path__ + "assets/AirbnbCerealBook.886339361d3ff50e8a95ac5cdc63a82e.woff";